import {
    CLEAR_FILE_DATA_FORM,
    FILE_DATA_FORM_ADD_MODEL,
    FILE_DATA_FORM_ADD_SKU,
    FILE_DATA_FORM_REMOVE_MODEL,
    FILE_DATA_FORM_REMOVE_SKU,
    SAVING_FILE_DATA,
    SAVING_FILE_DATA_FAILURE,
    SAVING_FILE_DATA_SUCCESS,
    UPDATE_FILE_DATA_FORM,
    UPLOADING_FILE,
    UPLOADING_FILE_FAILURE,
    UPLOADING_FILE_SUCCESS,
} from '../actions/types'

const INITIAL_STATE = {
    url: '',
    label: '',
    brand: '',
    skus: [],
    models: [],
    assetType: '0',
    uploading: false,
    loading: false,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPLOADING_FILE:
            return {
                ...state,
                uploading: true,
            }

        case SAVING_FILE_DATA:
            return {
                ...state,
                loading: true,
            }

        case SAVING_FILE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case SAVING_FILE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            }

        case UPLOADING_FILE_SUCCESS:
            return {
                ...state,
                uploading: false,
                url: action.url,
            }
        case UPLOADING_FILE_FAILURE:
            return {
                ...state,
                uploading: false,
            }

        case CLEAR_FILE_DATA_FORM:
            return {
                ...state,
                url: '',
                label: '',
                brand: '',
                skus: [],
                models: [],
                assetType: '0',
            }

        case UPDATE_FILE_DATA_FORM:
            return {
                ...state,
                ...action.payload,
            }

        case FILE_DATA_FORM_ADD_SKU:
            return {
                ...state,
                skus: [...state.skus, action.payload],
            }

        case FILE_DATA_FORM_ADD_MODEL:
            return {
                ...state,
                models: [...state.models, action.payload],
            }

        case FILE_DATA_FORM_REMOVE_SKU:
            return {
                ...state,
                skus: state.skus.filter(sku => sku !== action.payload),
            }

        case FILE_DATA_FORM_REMOVE_MODEL:
            return {
                ...state,
                models: state.models.filter(model => model !== action.payload),
            }

        default:
            return state
    }
}

export default reducer
